<template>
  <v-card>
    <v-card-title>
      <span class="title">{{titulo}}</span>
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        class="mr-3"
        @click="editar()"
      >
        <v-icon small>edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="editando">

      <v-dialog
        v-model="editando"
        persistent
        max-width="800px"
      >
        <v-card class="modal-principal">
          <v-card-title>{{titulo}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="max-height: 400px;overflow-y:auto;">
            <v-alert
              v-model="alerta.mostrar"
              dismissible
              :type="alerta.tipo"
            >
              {{alerta.mensaje}}
            </v-alert>
            <v-container grid-list-lg>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete
                    v-model="edicion.item.tipo_archivo_id"
                    :items="combos.tipoArchivos"
                    :item-text="'nombre'"
                    :item-value="'id'"
                    label="Tipo archivo"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('item.tipo_archivo_id')"
                    :data-vv-name="'item.tipo_archivo_id'"
                    data-vv-validate-on="none"
                  ></v-autocomplete>
                </v-flex>

                <v-flex
                  xs12
                  sm8
                >
                  <v-text-field
                    v-model="edicion.item.descripcion"
                    v-validate="{required: true, max: 100 }"
                    :error-messages="errors.collect('item.descripcion')"
                    label="Descripción"
                    data-vv-name="item.descripcion"
                    data-vv-validate-on="none"
                  ></v-text-field>
                </v-flex>

              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex xs12>
                  <v-label color="medium">Archivo</v-label>
                </v-flex>
                <v-flex
                  xs8
                  align-center
                  px-0
                >
                  <span class="file-upload-input-box">
                    <span v-if="fileUpload.archivos.length > 0"> {{ fileUpload.archivos[0].name }} </span>
                    <span v-else-if="itemSeleccionado.archivo"> {{ itemSeleccionado.archivo }} </span>
                  </span>
                </v-flex>
                <v-flex
                  xs2
                  align-rigth
                  px-0
                >
                  <vue-upload-component
                    :headers="fileUpload.headers"
                    :multiple="fileUpload.multiple"
                    ref="upload"
                    v-model="fileUpload.archivos"
                    :post-action="fileUpload.urlPost"
                    @input-file="subirArchivo"
                    input-id="upload"
                    class=""
                  >
                    <v-btn
                      color="secondary"
                      small
                      dark
                      class="v-btn--full ma-0"
                    >
                      Seleccionar
                    </v-btn>
                  </vue-upload-component>
                </v-flex>
                <v-flex
                  xs2
                  align-center
                  px-0
                >
                  <v-btn
                    mx-0
                    color="primary"
                    small
                    dark
                    :loading="subiendo"
                    v-show="fileUpload.mostrarBtnSubir"
                    @click.prevent="$refs.upload.active = true"
                  >
                    Subir
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <span
                    v-if="fileUpload.error"
                    class="danger--text"
                  >
                    Error: {{ fileUpload.error }}
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <botones-cancelar-guardar
              v-bind:guardando="guardando"
              v-on:alGuardar="guardar"
              v-on:alCancelar="cerrar"
              v-if="!subiendo"
            ></botones-cancelar-guardar>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-card-text>
      <v-subheader class="grey lighten-4 primary--text px-2">Datos del Archivo</v-subheader>
      <v-layout
        row
        wrap
        px-2
      >
        <v-flex
          v-bind="colDetalle"
          sm9
        >
          <dt>Tipo Archivo</dt>
          <dd>
            {{itemSeleccionado.tipo_archivo.nombre}}
          </dd>
        </v-flex>

        <v-flex
          v-bind="colDetalle"
          sm5
        >
          <dt>Descripción</dt>
          <dd>
            {{itemSeleccionado.descripcion }}
          </dd>
        </v-flex>

        <v-flex
          v-bind="colDetalle"
          sm6
        >
          <dt>Archivo</dt>
          <dd>
            <a
              v-if="itemSeleccionado.archivo"
              :href="itemSeleccionado.archivo_url"
              target="_blank"
            >Descargar</a>
          </dd>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash'
import mixinseccionModulo from '@/mixins/seccionModulo'
import Combo from '@/api/combo'
import Modelo from '@/api/persona'
import VueUploadComponent from 'vue-upload-component'
import storageUtil from '@/helpers/storage'

export default {
  name: 'ArchivosDetalleDatosGenerales',
  mixins: [mixinseccionModulo],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    VueUploadComponent
  },
  computed: {
    usuario () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      titulo: 'Archivo',
      seccion: 'general',
      combos: { tipoArchivos: [] },
      itemSeleccionado: this.item,
      modeloApi: Modelo,
      fileUpload: {
        headers: {
          Authorization: null
        },
        multiple: false,
        archivos: [],
        mostrarBtnSubir: false,
        urlPost: null,
        error: null
      },
      archivoParaImpactar: null,
      subiendo: false
    }
  },
  mounted () {
    let vm = this
    let token = storageUtil.getKey('auth_token')
    vm.cargando = false
    vm.fileUpload.urlPost = vm.modeloApi.obtenerUrlSubirArchivo()
    vm.fileUpload.headers.Authorization = `Bearer ${token}`
  },
  methods: {
    editar () {
      let vm = this

      this.$set(vm.edicion, 'item', _.cloneDeep(this.itemSeleccionado))
      vm.edicion.accion = 'guardar'
      vm.prepararEdicion().then(() => {
        vm.editando = true
      })
    },
    prepararEdicion () {
      let vm = this

      let dataCombos = {
        grupoEntidades: {
          tipoArchivos: {
            codigo: 'tipo_archivo',
            itemVacio: true
          }
        }
      }

      return Combo.listado(dataCombos).then(
        data => {
          vm.llenarCombos(data)
          vm.cargando = false
          Promise.resolve()
        },
        error => {
          vm.mostrarError(error)
          // vm.soloLectura = true
          vm.cargando = false
          Promise.reject(error)
        }
      )
    },
    guardar () {
      let vm = this
      vm.$validator.validate().then(valid => {
        if (valid) {
          vm.ocultarAlerta()
          vm.guardando = true

          vm.modeloApi.guardarArchivos(vm.usuario.persona_id, vm.edicion.item).then(
            data => {
              vm.itemSeleccionado = _.assign(data)
              vm.guardando = false
              vm.cerrar()
            },
            error => {
              vm.guardando = false
              if (error.type === 422) {
                vm.mostrarErroresEnCampos(error)
              } else {
                vm.mostrarError(error)
              }
            }
          )
        }
      })
    },
    subirArchivo (newFile, oldFile, ref) {
      var vm = this
      var _ref = typeof ref !== 'undefined' ? ref : 'upload'

      if (newFile && newFile.active && !newFile.success) {
        vm.subiendo = true
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!vm.$refs[_ref].active) {
          vm.fileUpload.mostrarBtnSubir = true
          vm.fileUpload.error = null
          vm.subiendo = false
          vm.$refs[_ref].active = true
        }
      }

      if (newFile && oldFile) {
        if (newFile.success) {
          vm.edicion.item.archivo = newFile.response.file
          vm.$refs[_ref].clear()
          vm.fileUpload.mostrarBtnSubir = false
          vm.subiendo = false
          // onSuccess(newFile)
        }
        if (newFile.error) {
          switch (newFile.error) {
            case 'extension':
              vm.fileUpload.error = 'El archivo seleccionado debe ser .xlsx'
              break
            default:
              vm.fileUpload.error = newFile.error
              vm.$refs[_ref].clear()
              vm.fileUpload.mostrarBtnSubir = false
              break
          }

          vm.subiendo = false
        }
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.file-upload-input-box {
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 5px 0 0 5px;
  height: 28px;
  padding: 0 10px;
  margin-left: 5px;
}
.v-btn--full {
  width: 100%;
  cursor: pointer !important;
}
.tg {
  border-collapse: collapse;
  border-spacing: 0;
}
.tg td {
  font-family: Arial, sans-serif;
  font-size: 13px;
  padding: 7px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: black;
}
.tg th {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  padding: 5px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: black;
}
.tg .tg-bzci {
  font-size: 16px;
  text-align: center;
  vertical-align: top;
}
.tg .tg-jzjz {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: center;
  vertical-align: top;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.tg .tg-9apd {
  font-size: 14px;
  background-color: #c0c0c0;
  text-align: center;
  vertical-align: top;
}
.tg-key {
  font-weight: 700;
}
</style>
